import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'esri-sublayers-toggle, esri-sublayersToggle',
  template: `<div *ngFor="let sublayer of _sublayers" class="sublayers">
  <input type="checkbox" [checked]="sublayer.visible" (click)="onCheck($event, sublayer)" /> {{sublayer.title}}
  <esri-sublayers-toggle [layer]="sublayer" *ngIf="sublayer.sublayers && sublayer.sublayers.toArray()"></esri-sublayers-toggle><!--recursive sub layers-->
</div>
`,
  styles: [`.sublayers{padding-left:15px}`]
})
export class SubLayersToggleComponent {
  _sublayers: __esri.Collection<__esri.Sublayer>;
  @Input()
  set layer(layer) {
    this._sublayers = layer.sublayers
      .toArray()
      .slice()
      .reverse();
  }

  constructor() {}

  onCheck($event: any, sublayer: __esri.Sublayer) {
    sublayer.visible = $event.target.checked;
  }
}
